module.exports = __webpack_public_path__ + "static/media/05-Banque-Mondiale.591d0627.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/realisations/projet_banque-mondiale/05-Banque-Mondiale.jpg
// module id = 1184
// module chunks = 37